import React from 'react';
import { Link } from 'react-router-dom';

const INTENTS = [
  { to: '/pontos-de-corte', question: 'Qual é o ponto de corte do Mini Mental?', note: 'Brucki, Bertolucci e Lourenço e Veras, por escolaridade.' },
  { to: '/interpretacao-dos-resultados', question: 'Como interpretar a pontuação do Mini Mental?', note: 'referência, escolaridade e o que o escore não responde.' },
  { to: '/escolaridade', question: 'Como a escolaridade altera o Mini Mental?', note: 'medianas brasileiras e por que mediana não é corte.' },
  { to: '/mini-mental-ou-moca', question: 'Mini Mental ou MoCA: qual usar?', note: 'o que cada instrumento avalia e quando usar cada um.' },
  { to: '/mini-mental-telessaude', question: 'O Mini Mental pode ser aplicado por telessaúde?', note: 'o que muda na modalidade remota e como registrar.' },
  { to: '/acompanhamento-e-queda-de-pontos', question: 'Queda de pontos no Mini Mental é significativa?', note: 'variabilidade teste-reteste e efeito de aprendizagem.' }
];

export default function IntentLinks() {
  return (
    <section aria-labelledby="intent-links-title" className="max-w-[1180px] mx-auto px-4 pb-12">
      <h2 id="intent-links-title" className="mb-6 border-b border-[var(--border-strong)] pb-3">Dúvidas comuns sobre o resultado</h2>
      <ul className="grid gap-x-10 gap-y-5 md:grid-cols-2">
        {INTENTS.map((item) => (
          <li key={item.to} className="border-b border-[var(--border)] pb-5 last:border-b-0">
            <Link to={item.to} className="group no-underline">
              <span className="block text-lg font-semibold text-[var(--primary)] group-hover:underline underline-offset-4">{item.question}</span>
              <span className="mt-1 block text-sm leading-relaxed text-[var(--text-muted)]">{item.note}</span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
